const messages = require('./vi-VN/messages.json');

export default messages;
